import React, { useState, useEffect, useCallback } from 'react';
import { Modal, Col, FormGroup, Row } from 'react-bootstrap';
import Select from 'react-select';
import { useDispatch, useSelector } from 'react-redux';
import { MultiSelect } from 'react-multi-select-component';
import { useTranslation } from 'react-i18next';
import * as systemMasterAction from '../../../SystemMasters/Store/SystemMasters.action';
import * as bomLibAction from '../../../Library/BomLibrary/store/BomLibrary.action';
import * as supplierToDo from './store/SupplierToDo.action';
import { createOptions, bomConfigData, customStylesProductAddEdit } from '../../../../Components/helper';

function SupplerSetting({ callFn }) {
  const reducer = useSelector((reducerstate) => reducerstate);
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const { t } = useTranslation('common');
  const sectionOptionsArray = [{ value: 'BOM', label: 'Bill of Materials' }];

  const {
    UserDetails: { userInfo },
    SystemMastersDetails: { pcTypeList, placement_master, BOMTypeList },
    BomLibraryDetails: { ReferenceSupplier },
    SupplierTodoModule: { supplierConfigData },
  } = reducer;
  const [disabledFields, setDisabledFields] = useState([]);
  const [state, setState] = useState({
    productTypeId: [],
    assignee: [],
    module: null,
    selectionType: 'component',
    placementType: [],
    bomType: null,
    bomFields: [],
    errorFields: [],
  });
  const [supplierOptions, setSupplierOptions] = useState([]);
  const productTypeOptions = pcTypeList?.map((ele) => ({
    label: ele.name,
    value: ele._id,
  }));

  const placementTypeOptions = placement_master?.map((ele) => ({
    label: ele.name,
    value: ele._id,
  }));

  const bomTypeOptions = BOMTypeList?.map((ele) => ({
    label: ele.name,
    value: ele._id,
  }));

  const toggleModal = () => {
    callFn();
    setShowModal(!showModal);
    setState((prevState) => ({
      ...prevState,
      productTypeId: [],
      assignee: [],
      module: null,
      selectionType: 'component',
      placementType: [],
      bomType: null,
      bomFields: [],
      errorFields: [],
    }));
  };

  useEffect(() => {
    if (supplierConfigData) {
      const filteredData = bomConfigData?.filter((data) => {
        return supplierConfigData?.bomFields?.includes(data.value);
      });

      const filterPlacementData = placement_master?.filter((data) => {
        return supplierConfigData?.newPlacement?.includes(data._id);
      });
      const placementOptions = filterPlacementData?.map((ele) => ({
        label: ele.name,
        value: ele._id,
      }));

      setState((prevState) => ({
        ...prevState,
        selectionType: supplierConfigData?.allBoms ? 'component' : 'placement',
        bomFields: filteredData,
        placementType: placementOptions,
      }));
    }
  }, [supplierConfigData]);

  useEffect(() => {
    const init = async () => {
      await Promise.all([
        dispatch(
          systemMasterAction.getPCTypesDetails({
            loggedInUserId: userInfo?.userId,
            isActive: true,
            tier: 'Tier1',
          }),
        ),
        dispatch(bomLibAction.fetchBomReferenceSupplier()),
        dispatch(systemMasterAction.getBOMTypeDetails({ isAllRecord: true })),
      ]);
    };

    init();
  }, [dispatch, userInfo?.userId]);

  useEffect(() => {
    if (state.productTypeId && state?.module && state?.bomType) {
      const params = {
        productTypeId: state?.productTypeId?.value,
        module: state?.module?.value,
        bomType: state?.bomType?.value,
      };
      dispatch(supplierToDo.getSupplierConfigData(params));
    }
  }, [state.productTypeId, state?.module, state?.bomType]);

  useEffect(() => {
    if (state?.bomFields) {
      setDisabledFields(state?.bomFields?.map((ele) => ele.value) || []);
    }
  }, [state?.bomFields]);

  useEffect(() => {
    if (state.productTypeId) {
      const id = state.productTypeId.value;

      const list = ReferenceSupplier?.filter((element) =>
        Array.isArray(element?.supplierType) && element?.supplierType?.includes(id)
      );
      setSupplierOptions(createOptions(list, 'name', '_id'));
      setState((prevState) => ({
        ...prevState,
        assignee: [],
        module: null,
        selectionType: 'component',
        placementType: [],
        bomType: null,
        bomFields: [],
        errorFields: [],
      }));
    }
  }, [state.productTypeId, ReferenceSupplier]);

  const handleBasicDetail = useCallback(
    (key, value) => {
      if (key === 'bomType') {
        setState((prevState) => ({
          ...prevState,
          placementType: [],
          bomFields: [],
          errorFields: [],
          selectionType: 'component',
        }));
      }
      if (key === 'selectionType') {
        setState((prevState) => ({
          ...prevState,
          placementType: [],
          bomFields: [],
        }));
      }

      setState((prevState) => ({
        ...prevState,
        [key]: value,
      }));
    },
    [dispatch, userInfo?.userId],
  );

  useEffect(() => {
    const apiCall = async () => {
      dispatch(
        systemMasterAction.getPlacementDetails({
          loggedInUserId: userInfo?.userId,
          bomTypeId: state?.bomType?.value,
        }),
      );
    };
    if (state?.bomType?.value) {
      apiCall();
    }
  }, [state?.bomType]);

  const isValidForm = () => {
    const errors = [];

    if (!state.productTypeId) errors.push('productTypeId');
    if (!state.assignee.length) errors.push('assignee');
    if (!state.module) errors.push('module');
    if (state.module?.value === 'BOM') {
      if (!state.bomType) errors.push('bomType');
      if (!state.selectionType) errors.push('selectionType');
      if (state.selectionType === 'placement' && !state.placementType.length) errors.push('placementType');
      if (state.bomType && !state.bomFields.length) errors.push('bomFields');
    }
    setState((prevState) => ({
      ...prevState,
      errorFields: errors,
    }));

    return errors.length <= 0;
  };

  const addEditConfig = () => {
    if (isValidForm()) {
      const obj = {
        productTypeId: state?.productTypeId?.value,
        suppliers: state?.assignee?.map((item) => item.value),
        module: state?.module?.value,
        bomType: state?.bomType?.value,
        allBoms: state?.selectionType === 'component' ? 'true' : 'false',

        bomFields: state?.bomFields?.map((item) => item.value),
      };

      if (state?.selectionType === 'placement') {
        obj.newPlacement = state?.placementType?.map((item) => item.value);
      }
      dispatch(supplierToDo.saveToDoConfigData(obj, t));
    }
  };

  useEffect(() => {
    if (state?.bomFields) {
      setDisabledFields(state?.bomFields?.map((item) => item.value) || []);
    }
  }, [state?.bomFields]);

  return (
    <div>
      <button onClick={toggleModal} type="button" className="filter-btn filter-button_add">
        <i className="icon-settings" />
      </button>

      <Modal show={showModal} backdrop="static" className="custom-modal modal-small" aria-labelledby="contained-modal-title-vcenter" onHide={toggleModal}>
        <Modal.Header>
          <div className="d-flex justify-content-between align-items-center w-100">
            <Modal.Title id="contained-modal-title-vcenter">
              <span> Configure Report</span>
            </Modal.Title>
            <span onClick={toggleModal} className="icon-close cursor-pointer" />
          </div>
        </Modal.Header>
        <Modal.Body>
          <FormGroup>
            <div className="custom-react-select">
              <p className="asterisk-req f-13 m-0">
                {t('SUPPLIER_TO_DO.PRODUCT_TYPE')}
                <span>*</span>
              </p>

              <Select
                name="productTypeId"
                options={productTypeOptions}
                value={state.productTypeId}
                onChange={(selected) => {
                  handleBasicDetail('productTypeId', selected);
                }}
                styles={customStylesProductAddEdit}
                placeholder={t('SUPPLIER_TO_DO.SELECT_PRODUCT_TYPE')}
              />

              {state.errorFields.includes('productTypeId') && <p className="mb-0 error-message">{t('SUPPLIER_TO_DO.PRODUCT_TYPE_REQUIRED')}</p>}
            </div>
          </FormGroup>
          <FormGroup>
            <div className="custom-react-select select-min-height">
              <p className="f-13 m-0 asterisk-req">
                {t('SUPPLIER_TO_DO.ASSIGNEE')}
                <span>*</span>
              </p>
              <MultiSelect
                options={supplierOptions}
                className="custom-multiselect w-100"
                value={state.assignee}
                labelledBy={t('CUSTOM_MODULE.SELECT_SUPPLIER')}
                overrideStrings={{
                  selectSomeItems: t('CUSTOM_MODULE.SELECT_SUPPLIER'),
                  search: t('CUSTOM_MODULE.SEARCH_SUPPLIER'),
                }}
                ClearSelectedIcon={null}
                onChange={(selected) => {
                  handleBasicDetail('assignee', selected);
                }}
              />
              {state.errorFields.includes('assignee') && <p className="mb-0 error-message">{t('SUPPLIER_TO_DO.SUPPLIER')}</p>}
            </div>
          </FormGroup>
          <FormGroup>
            <div className="custom-react-select">
              <p className="asterisk-req f-13 m-0">
                {t('SUPPLIER_TO_DO.MODULE')}
                <span>*</span>
              </p>
              <Select
                name="module"
                options={sectionOptionsArray}
                value={state.module}
                onChange={(selected) => {
                  handleBasicDetail('module', selected);
                }}
                placeholder={t('SUPPLIER_TO_DO.SELECT_MODULE')}
                styles={customStylesProductAddEdit}
              />
              {state.errorFields.includes('module') && <p className="mb-0 error-message">{t('SUPPLIER_TO_DO.MODULE_REQUIRED')}</p>}
            </div>
          </FormGroup>
          {state.module?.value === 'BOM' && (
            <>
              <FormGroup>
                <div className="custom-react-select">
                  <p className="asterisk-req f-13 m-0">
                    {t('SUPPLIER_TO_DO.BOM_TYPE')}
                    <span>*</span>
                  </p>
                  <Select
                    name="bomType"
                    options={bomTypeOptions}
                    value={state.bomType}
                    onChange={(selected) => {
                      handleBasicDetail('bomType', selected);
                    }}
                    placeholder={t('SUPPLIER_TO_DO.BOM_TYPE')}
                    styles={customStylesProductAddEdit}
                  />
                  {state.errorFields.includes('bomType') && <p className="mb-0 error-message">{t('SUPPLIER_TO_DO.BOM_TYPE_REQUIRED')}</p>}
                </div>
              </FormGroup>
              {state?.bomType && (
                <>
                  <p className="f-13 m-0 asterisk-req">
                    BOM Source
                    <span>*</span>
                  </p>
                  <Row>
                    <Col>
                      <div className="d-flex custom-radio">
                        <input
                          type="radio"
                          id="component"
                          name="selectionType"
                          value="component"
                          checked={state.selectionType === 'component'}
                          onChange={(e) => handleBasicDetail('selectionType', e.target.value)}
                          className="mr-2"
                        />
                        <label htmlFor="component">{t('SUPPLIER_TO_DO.COMPONENT')}</label>
                      </div>
                    </Col>
                    <Col>
                      <div className="d-flex custom-radio">
                        <input
                          type="radio"
                          className="mr-2"
                          id="placement"
                          name="selectionType"
                          value="placement"
                          checked={state.selectionType === 'placement'}
                          onChange={(e) => handleBasicDetail('selectionType', e.target.value)}
                        />
                        <label htmlFor="placement">{t('SUPPLIER_TO_DO.PLACEMENT')}</label>
                      </div>
                    </Col>
                  </Row>
                </>
              )}

              {state.selectionType === 'placement' && (
                <>
                  <FormGroup>
                    <div className="custom-react-select select-min-height">
                      <p className="f-13 m-0 asterisk-req">
                        {t('SUPPLIER_TO_DO.PLACEMENT')}
                        <span>*</span>
                      </p>
                      <MultiSelect
                        options={placementTypeOptions}
                        className="custom-multiselect w-100"
                        value={state.placementType}
                        labelledBy={t('SUPPLIER_TO_DO.SELECT_BOM_PLACEMENT')}
                        overrideStrings={{
                          selectSomeItems: t('SUPPLIER_TO_DO.SELECT_BOM_PLACEMENT'),
                          search: t('SUPPLIER_TO_DO.SELECT_BOM_PLACEMENT'),
                        }}
                        ClearSelectedIcon={null}
                        onChange={(selected) => {
                          handleBasicDetail('placementType', selected);
                        }}
                      />
                      {state.errorFields.includes('placementType') && <p className="mb-0 error-message">{t('SUPPLIER_TO_DO.PLACEMENT_REQUIRED')}</p>}
                    </div>
                  </FormGroup>
                  <FormGroup>
                    <div className="custom-react-select select-min-height">
                      <p className="f-13 m-0 asterisk-req">
                        {t('SUPPLIER_TO_DO.BOM_FIELDS')}
                        <span>*</span>
                      </p>
                      <MultiSelect
                        options={bomConfigData?.map((e) => ({ ...e, disabled: disabledFields?.includes(e.value) }))}
                        className="custom-multiselect w-100"
                        value={state.bomFields}
                        labelledBy={t('SUPPLIER_TO_DO.SELECT_BOM_FIELDS')}
                        overrideStrings={{
                          selectSomeItems: t('SUPPLIER_TO_DO.SELECT_BOM_FIELDS'),
                          search: t('SUPPLIER_TO_DO.SELECT_BOM_FIELDS'),
                        }}
                        ClearSelectedIcon={null}
                        onChange={(selected) => {
                          handleBasicDetail('bomFields', selected);
                        }}
                      />
                      {state.errorFields.includes('bomFields') && <p className="mb-0 error-message">{t('SUPPLIER_TO_DO.BOM_FIELDS_REQUIRED')}</p>}
                    </div>
                  </FormGroup>
                </>
              )}
              {state?.bomType && state.selectionType === 'component' && (
                <FormGroup>
                  <div className="custom-react-select select-min-height">
                    <p className="f-13 m-0 asterisk-req">
                      {t('SUPPLIER_TO_DO.ALL_BOMS')}
                      <span>*</span>
                    </p>
                    <MultiSelect
                      options={bomConfigData?.map((e) => ({ ...e, disabled: disabledFields?.includes(e.value) }))}
                      className="custom-multiselect w-100"
                      value={state.bomFields}
                      labelledBy={t('SUPPLIER_TO_DO.SELECT_ALL_BOMS')}
                      overrideStrings={{
                        selectSomeItems: t('SUPPLIER_TO_DO.SELECT_ALL_BOMS'),
                        search: t('SUPPLIER_TO_DO.SELECT_ALL_BOMS'),
                      }}
                      ClearSelectedIcon={null}
                      onChange={(selected) => {
                        handleBasicDetail('bomFields', selected);
                      }}
                    />
                    {state.errorFields.includes('bomFields') && <p className="mb-0 error-message">{t('SUPPLIER_TO_DO.BOM_FIELDS_REQUIRED')}</p>}
                  </div>
                </FormGroup>
              )}
            </>
          )}
          <div className="modal-buttons mt-4 d-flex justify-content-between">
            <button onClick={toggleModal} type="button" className="btn btn-default">
              {t('SUPPLIER_TO_DO.CANCEL')}
            </button>
            <button onClick={addEditConfig} type="button" className="btn btn-default">
              {t('SUPPLIER_TO_DO.CONFIGURE')}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default SupplerSetting;
